import { axios } from '@/utils/request'

const api = {
  purchaseOrder: '/stock/purchase'
}
const api2 = {
  storageAccessory: '/stock/selectutils'
}

const api3 = {
  accessory: '/stock/selectutils'
}

// 采购意向单转采购单
export function editPurchaseApplication (parameter) {
  return axios({
    url: api.purchaseOrder + '/editPurchaseApplication',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


// 查看文件
export function getPurchasePic (parameter) {
  return axios({
    url: api.purchaseOrder + '/getPurchasePic',
    method: 'get',
    params: parameter,
  })
}

// 删除禁用文件
export function delPurchasePic (parameter) {
  return axios({
    url: api.purchaseOrder + '/delPurchasePic',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}



// 更改物流信息
export function updatePurchaseLogistics (parameter) {
  return axios({
    url: api.purchaseOrder + '/updatePurchaseLogistics',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 比对现有配件是否满足供应商下配件
export function checkSupplier (parameter) {
  return axios({
    url: api3.accessory + '/checkSupplier',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


// 采购单入库
export function manualaccessorystorage (parameter) {
  return axios({
    url: api.purchaseOrder + '/manualaccessorystorage',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


// 采购意向单审核
export function auditIntention (parameter) {
  return axios({
    url: api.purchaseOrder + '/auditIntention',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 编辑采购意向单
export function updateIntention (parameter) {
  return axios({
    url: api.purchaseOrder + '/updateIntention',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getSupplierPayment (parameter) {
  return axios({
    url: api3.accessory + '/getSupplierPayment',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function delpurchaseapplication (parameter) {
  return axios({
    url: api.purchaseOrder + '/delpurchaseapplication',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function forbidden (parameter) {
  return axios({
    url: api.purchaseOrder + '/forbidden',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getonepurchaseapplication (parameter) {
  return axios({
    url: api.purchaseOrder + '/getonepurchaseapplication',
    method: 'post',
    data: parameter,

  })
}

export function getonepurchaseorder (parameter) {
  return axios({
    url: api.purchaseOrder + '/getonepurchaseorder',
    method: 'post',
    data: parameter,

  })
}

// 根据供应商获取配件
export function selectaccessory (parameter) {
  return axios({
    url: api2.storageAccessory + '/getSupplierAccessory',
    method: 'get',
    params: parameter
  })
}

// 获取配件
export function selectaccessory2 (parameter) {
  return axios({
    url: api2.storageAccessory + '/selectaccessory',
    method: 'get',
    params: parameter
  })
}



export function purchaseapplicationlist (parameter) {
  return axios({
    url: api.purchaseOrder + '/purchaseapplicationlist',
    method: 'get',
    params: parameter
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}

export function getPurchaseOrderList (parameter) {
  return axios({
    url: api.purchaseOrder + '/purchaseorderlist',
    method: 'get',
    params: parameter
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}

export function addpurchaseapplication (parameter) {
  return axios({
    url: api.purchaseOrder + '/addpurchaseapplication',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getUnitPrice (parameter) {
  return axios({
    url: api3.accessory + '/getUnitPrice',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function editpurchaseorder (parameter) {
  return axios({
    url: api.purchaseOrder + '/editpurchaseorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function addpurchaseorder (parameter) {

  return axios({
    url: api.purchaseOrder + '/addpurchaseorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function delpurchaseorder (parameter) {
  return axios({
    url: api.purchaseOrder + '/delpurchaseorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function selectenterprise (parameter) {
  return axios({
    url: api3.accessory + '/selectsupplier',
    method: 'get',
    params: parameter,

  })
}

// 申请意向转申请采购单
export function intentiontopurchase (parameter) {
  return axios({
    url: api.purchaseOrder + '/intentiontopurchase',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const purchaseOrderExport = api.purchaseOrder + '/export'
